module.exports = __webpack_public_path__ + "img/3.9e9f25f7.jpg";